// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/facilities.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/facilities.proto.
 */
export const file_proto_model_core_place_types_facilities = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2ZhY2lsaXRpZXMucHJvdG8SBmNhcm1lbiqwAQoTRmFjaWxpdGllc1BsYWNlVHlwZRIlCiFGQUNJTElUSUVTX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIlCiFGQUNJTElUSUVTX1BMQUNFX1RZUEVfUFVCTElDX0JBVEgQARIpCiVGQUNJTElUSUVTX1BMQUNFX1RZUEVfUFVCTElDX0JBVEhST09NEAISIAocRkFDSUxJVElFU19QTEFDRV9UWVBFX1NUQUJMRRADQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM");

/**
 * Describes the enum carmen.FacilitiesPlaceType.
 */
export const FacilitiesPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_facilities, 0);

/**
 * Facilities place types
 *
 * @generated from enum carmen.FacilitiesPlaceType
 */
export const FacilitiesPlaceType = /*@__PURE__*/
  tsEnum(FacilitiesPlaceTypeSchema);

